import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Github } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-blue-900 text-white" data-id="element-101">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-102">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-103">
          <div data-id="element-104">
            <h3 className="text-2xl font-bold mb-4" data-id="element-105">CloudTech</h3>
            <p className="text-blue-200 mb-4" data-id="element-106">
              Transforming businesses through innovative cloud and AI solutions.
            </p>
            <div className="flex space-x-4" data-id="element-107">
              <a href="#" className="text-blue-200 hover:text-white" data-id="element-108">
                <Facebook size={20} data-id="element-109" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white" data-id="element-110">
                <Twitter size={20} data-id="element-111" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white" data-id="element-112">
                <Linkedin size={20} data-id="element-113" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white" data-id="element-114">
                <Instagram size={20} data-id="element-115" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white" data-id="element-116">
                <Github size={20} data-id="element-117" />
              </a>
            </div>
          </div>
          <div data-id="element-118">
            <h4 className="text-lg font-semibold mb-4" data-id="element-119">Services</h4>
            <ul className="space-y-2" data-id="element-120">
              <li data-id="element-121">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-122">
                  Cloud Applications
                </a>
              </li>
              <li data-id="element-123">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-124">
                  SharePoint Solutions
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-126">
                  Power Platform
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-128">
                  Data Applications
                </a>
              </li>
              <li data-id="element-129">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-130">
                  AI Development
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-131">
            <h4 className="text-lg font-semibold mb-4" data-id="element-132">Company</h4>
            <ul className="space-y-2" data-id="element-133">
              <li data-id="element-134">
                <a href="#about" className="text-blue-200 hover:text-white" data-id="element-135">
                  About Us
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-137">
                  Careers
                </a>
              </li>
              <li data-id="element-138">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-139">
                  Blog
                </a>
              </li>
              <li data-id="element-140">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-141">
                  Press
                </a>
              </li>
              <li data-id="element-142">
                <a href="#contact" className="text-blue-200 hover:text-white" data-id="element-143">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-144">
            <h4 className="text-lg font-semibold mb-4" data-id="element-145">Resources</h4>
            <ul className="space-y-2" data-id="element-146">
              <li data-id="element-147">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-148">
                  Documentation
                </a>
              </li>
              <li data-id="element-149">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-150">
                  Support
                </a>
              </li>
              <li data-id="element-151">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-152">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-153">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-154">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-155">
                <a href="#" className="text-blue-200 hover:text-white" data-id="element-156">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-blue-800 mt-12 pt-8 text-center text-blue-200" data-id="element-157">
          <p data-id="element-158">
            &copy; {new Date().getFullYear()} CloudTech Solutions. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};